export default __webpack_public_path__ + "static/media/navbar-logo-original.03aa9b8d.svg";